module.exports = __webpack_public_path__ + "img/menu.145e4f40.svg";